export default "__VITE_ASSET__DYumS9ev__"